import React, { useEffect, useState } from 'react';
import { addMonths } from 'date-fns';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DatePickerHandler({
    form_data,
    setFormData,
    Name = "input",
    Label = "",
    minDate="",
    maxDate="",
    is_disabled = false
}) {
    const [selectedDate, setSelectedDate] = useState(form_data[Name] ? new Date(form_data[Name]) : new Date());

    useEffect(() => {
        if (form_data[Name]) {
            setSelectedDate(new Date(form_data[Name]));
        }
    }, [form_data, Name]);

    const handleChange = (date) => {
        setSelectedDate(date);
        setFormData(prev => ({
            ...prev,
            [Name]: date ? date.toISOString().split('T')[0] : "" // Save as YYYY-MM-DD
        }));
    };

    return (
        <div className="form-group CustomDatepicker">
            {Label && <label className="form-label">{Label}</label>}
            <DatePicker
                selected={selectedDate}
                onChange={handleChange}
                dateFormat="dd/MM/yyyy"
                minDate={minDate}
                maxDate={maxDate}
                // minDate={new Date()}
                // maxDate={addMonths(new Date(), 5)}
                disabled={is_disabled}
                className="form-control"
                placeholderText={`Select ${Label}`}
                isClearable
            />
        </div>
    );
}
